import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AccessService } from '../../services/access/access.service';
import { UserType } from '../../shared/models/user.model';

export const authorizationGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const accessService = inject(AccessService);
  const { ADMIN } = UserType;

  if (accessService.hasRole(route.data['roles'])) {
    return true;
  }

  if (accessService.userInfo()?.type === ADMIN) {
    return router.createUrlTree(['/control-panel'])
  }

  return router.createUrlTree(['/']);
};
